const PATH_PREFIX = '/admin/account/:userID';

export default [
  {
    name: 'user.dashboard',
    path: `${PATH_PREFIX}/`,
  },
  {
    name: 'user.dashboard',
    path: `${PATH_PREFIX}/dashboard`,
  },
  {
    name: 'user.supports',
    path: `${PATH_PREFIX}/supports`,
  },
  {
    name: 'user.profile',
    path: `${PATH_PREFIX}/profile`,
  },
  {
    name: 'user.works',
    path: `${PATH_PREFIX}/works`,
  },
  {
    name: 'user.works.new',
    path: `${PATH_PREFIX}/work/new`,
  },
  {
    name: 'user.work.edit',
    path: `${PATH_PREFIX}/work/:companyID`,
  },
  {
    name: 'user.contacts',
    path: `${PATH_PREFIX}/contacts`,
  },
  {
    name: 'user.media',
    path: `${PATH_PREFIX}/media`,
  },
  {
    name: 'user.configuration',
    path: `${PATH_PREFIX}/configuration`,
  },
];
